export const makeTransition = (
  attr: string,
  speed: number | string = 0.15,
  easing = 'ease-out'
) => `${attr} ${String(speed)}s ${easing}`
